import {Text} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {LegendItemProps} from './interfaces'
import {classes} from './item.st.css'

export const LegendItem = ({color, price, name}: LegendItemProps) => {
  const {isMobile} = useEnvironment()

  return (
    <li className={classNames(classes.legendItem, classes.mobileGap)}>
      <div
        className={classes.color}
        style={{backgroundColor: color, border: color === '#fff' ? '1px solid black' : undefined}}
      />
      <div className={classes.textContainer}>
        <Text className={classes.name}>{name}</Text>
        <Text className={isMobile ? classes.mobilePrice : classes.price}>{price}</Text>
      </div>
    </li>
  )
}
